// import React from 'react';
// import MultiStep from 'react-multistep'
// import { Payment } from './Payment';
// import { PersonalDetails } from './PersonalDetails';
// import { Subscriptions } from './Subscriptions';
// import { Summary } from './Summary';

// export const Renew = props => {
//     const steps = [
//         {name: 'PersonaDetails', component: <PersonalDetails/> },
//         {name: 'Subscriptions', component: <Subscriptions/>},
//         {name: 'Payment', component: <Payment/> },
//         {name: 'Finalise', component:<Summary/> }
//       ];

//     const prevStyle = {'background': '#33c3f0', 'borderWidth': '2px'}
//     const nextStyle = {'background': '#33c3f0',  'borderWidth': '2px'}
//     return(
//         <MultiStep steps={steps} prevStyle={prevStyle} nextStyle={nextStyle} />
//     )
// }
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faGift } from '@fortawesome/free-solid-svg-icons';

import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { PersonalDetailsPage } from './PersonalDetailsPage';
import { SubscriptionsPage } from './SubscriptionsPage';
import { Payment } from './Payment';
import ReactLoading from 'react-loading';
import { useAlert } from 'react-alert';
import Alert from 'react-bootstrap/Alert';

import { Prompt } from 'react-router-dom';

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
        background: '#003566',
    //   backgroundImage:
    //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  completed: {
    '& $line': {
        background: '#003566',
    //   backgroundImage:
    //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    // backgroundImage:
    //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    background: '#003566',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    // backgroundImage:
    //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    background: '#003566',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <FontAwesomeIcon icon={faUser} />,
    2: <FontAwesomeIcon icon={faEnvelope} />,
    3: <FontAwesomeIcon icon={faCreditCard} />,
    4: <FontAwesomeIcon icon={faGift} />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));


export const Renew = props => {
  const [renew, setRenew] = React.useState(false);
  const [renewDate, setRenewDate] = React.useState('');

  const[editedDetails, setEditedDetails] = React.useState(false);
  const[detailsData, setDetailsData] = React.useState('');
  const [invalidEmail, setInvalidEmail] = React.useState(true);
  const [invalidPhone, setInvalidPhone] = React.useState(true);
  const [invalidHomePhone, setInvalidHomePhone] = React.useState(true);

  const [editedSubscriptions, setEditedSubscriptions] = React.useState(false);
  const [subscriptionsData, setSubscriptionsData] = React.useState('');

  const [editedPayment, setEditedPayment] = React.useState(false);
  const [paymentData, setPaymentData] = React.useState('');

  const [notLoading, setNotLoading] = React.useState(true);
  const [activeStep, setActiveStep] = React.useState(0);
  const [expiry, setExpiry] = React.useState('');
  const [disableNext, setDisableNext] = React.useState(false);
  const [isDigital] = React.useState(sessionStorage.getItem('isDigital'));

  const [processingPayment, setProcessingPayment] = React.useState(false);


  const classes = useStyles();
  const steps = getSteps();

  //Gets the member's expiry date and renders the appropriate component
  React.useEffect(() => {
    var memberExpiry = sessionStorage.getItem('memberExpiry');    

    // var memberExpiryString = memberExpiry.split("-").reverse().join("-");
    var memberExpiryString = new Date(memberExpiry).toLocaleString('en-AU', {dateStyle: 'full'});
    setRenewDate(memberExpiryString);
    
    //Gets todays date and add two months to it
    var advanceMonths = new Date();
    advanceMonths.setMonth(advanceMonths.getMonth() + 6);

    //If the member expiry date is larger than two months from now. Then they cannot renew
    var expiryDate = new Date(memberExpiry);
    if(expiryDate >= advanceMonths){
      //For testing setRenew to true, else leave it at false
      setRenew(false);
      // setRenew(true);
    } else {
      setRenew(true);
    }

  },[]);

  function getSteps() {
    if(sessionStorage.getItem('memberExpiry') === "2021-06-30" || sessionStorage.getItem('memberExpiry') === "2021-07-31"){
      return ['Personal Details', 'Notification Preferences', 'Payment', 'Spin To Win'];
    } else {
      return ['Personal Details', 'Notification Preferences', 'Payment'];
    }
  }

  function getStepContent(step, detailsEdited) {
    switch (step) {
      case 0:
        if(isDigital === 0){
          return <div>
            <div className="container">
                    <Alert variant="primary">
                      <Alert.Heading>Renew to become a digital member!</Alert.Heading>
                      <p className="text-justify">We’re striving towards sustainability and offer digital memberships only. Be sure to keep your details current and download the Bankstown Sports App so your digital membership card will always be handy!  </p>
                    </Alert>
                    </div>
                    <PersonalDetailsPage invalidEmail={invalidEmail} invalidHomePhone={invalidHomePhone} invalidPhone={invalidPhone} isEdited={detailsEdited} saveDetails={saveDetails} detailsData={detailsData}/>
                </div>;
        } else {
          return <PersonalDetailsPage invalidEmail={invalidEmail} invalidHomePhone={invalidHomePhone} invalidPhone={invalidPhone} isEdited={detailsEdited} saveDetails={saveDetails} detailsData={detailsData}/>;
        }
      case 1:
        return <SubscriptionsPage isEdited={editedSubscriptions} saveSubscriptions={saveSubscriptions} subscriptionsData={subscriptionsData} />;
      case 2:
        return <Payment isEdited={editedPayment} savePayment={savePayment} paymentData={paymentData}/>;
      default:
        return 'Unknown step';
    }
  }

  const alert = useAlert();

  const updateExpiry = (updatedExpiry) =>{
    var expiryString = new Date(updatedExpiry).toLocaleString('en-AU', {dateStyle: 'full'});
    setExpiry(expiryString);
  }

  const setNextButton = () =>{
    setDisableNext(false);
  }

  const savePayment = (formData) =>{
    setPaymentData(formData);
    if(formData.cvn && formData.expiryMonth && formData.expiryYear && formData.length && formData.name && formData.number){
      setDisableNext(false);
    } else {
      setDisableNext(true);
    }
  }

  const saveSubscriptions = (formData) =>{
    // console.log(formData);
    setSubscriptionsData(formData);
  }

  const saveDetails = (formData) =>{
    // console.log("Saving user details");
    setDetailsData(formData);
    //Disables the next button if required fields are not completed
    if(formData.mobilePhone.length !== 10 || !formData.email || !formData.jobTitle || !formData.residentialAddress || !formData.defaultPostalAddress){
      setDisableNext(true);
    } else {
      setDisableNext(false);
    }
  }

  //Calls the form data to update the users personal details.
  const updatePersonalDetails = () =>{ 
    return new Promise(function(resolve, reject){
      // console.log(detailsData.addressEdited);
    
    // console.log(detailsData);
    // console.log(sessionStorage.getItem('memberID'));

    //Format the data into an appropriate format so that way it can be thrown into the same endpoint
    //as the one being used for the personal details page
    var formDetails = {
      firstName: detailsData.firstName,
      lastName: detailsData.lastName,
      email: detailsData.email,
      mobile: detailsData.mobilePhone,
      homePhone: detailsData.homePhone,
      residentalAddress: detailsData.residentialAddress,
      postalAddress: detailsData.defaultPostalAddress,
      occupation: detailsData.jobTitle,
      sameAsResidental: detailsData.sameAsResidental,
      addressEdited: detailsData.addressEdited,
      isRenew: true
    };
    
    // console.log(formDetails);

    validateAddress(formDetails.postalAddress)
    .then(function(result){
      if(!result.success && detailsData.addressEdited){
        // console.log("INVALID ADDRESS");
        resolve({success: false, message: "Please double check your address."});
      } else {
        formDetails.postalFormat = result.format;
        validateAddress(formDetails.residentalAddress)
        .then(function(result){
          if(!result.success && detailsData.addressEdited){
            // console.log("INVALID RESIDENTIAL ADDRESS");
            resolve({success: false, message: "Please double check your residential address."});
          } else {
            // console.log("PROCEEDING EVERYTHING IS GOOD");
            //call the api here
            formDetails.format = result.format;
            fetch(localStorage.getItem('server') + 'member', {
              method: 'POST',
              body: JSON.stringify(formDetails),
              headers: {
                token: sessionStorage.getItem('token'),
                memberNumber: sessionStorage.getItem('memberNumber')
              }
            })
            .then(function(resp){
                return resp.json();
            })
            .then(function(data){
              if(data.status === 401){
                      // console.log("Invalid Token - Redirecting to login");
                      // props.history.push("");
                      alert.show(
                        <span ref={sessionRef}>
                            Your session has expired. Please login to continue.
                        </span>
                        , {
                            title: "Session Expired"
                    });
                  } else {
                  if(data.success){
                      // console.log("Successfully updated. Redirecting");
                      resolve({success: true});
                  } else {
                    if(data.status === 400){
                      setInvalidPhone(true);
                      setInvalidEmail(true);
                      setInvalidHomePhone(true);
                      data.invalidFields.forEach(function(field){
                        switch(field){
                          case 'email':
                            setInvalidEmail(false);
                            break;
                          case 'mobile':
                            setInvalidPhone(false);
                            break;
                          case 'homePhone':
                            setInvalidHomePhone(false);
                            break;
                          default:
                            break;
                        }
                      });
                    } else if(data.status === 404) {
                      alert.show("Please re-enter all compulsory fields", {
                        title: 'Error'
                      });
                    }
                    setActiveStep(0);
                    setNotLoading(true);
                  }
                }
            });
          }
        });
      }
    });
  })
  };

  const validateAddress = (address) =>{
    return new Promise(function(resolve, reject){
      var addressQuery = address.replace(/\s/g, '%20');
        fetch(localStorage.getItem('server') + 'api/app/experian?query=' + addressQuery, {
          method: 'GET'
          })
        .then(function(resp){
          return resp.json();
        })
        .then(function(data){
          // var success = false;
          // console.log(data);
          data.result.results.forEach(function(result){
            if(result.suggestion.replace(/ /g, "") === address.replace(/ /g, "")){
              // success = true;
              data = {success: true, format: result.format}
            }
          });
          resolve(data);
        });  
    })
    
  };

  const handlePayment = () =>{
    return new Promise(function(resolve, reject){
      // console.log("Making Payment");
      // console.log(paymentData);
      var valid = true;

      if(!paymentData.length){
        // console.log("Please select a length");
        valid = false;
      }
      if(!paymentData.number){
        // console.log("Please enter a card number");
        valid = false;
      }
      if(!paymentData.name){
        // console.log("Please enter the card name");
        valid = false;
      }
      if(!paymentData.expiryMonth){
        // console.log("Please enter the expiry month");
        valid = false;
      }
      if(!paymentData.expiryYear){
        // console.log("Please enter the expiry year");
        valid = false;
      }
      if(!paymentData.cvn){
        // console.log("Please enter the card cvn");
        valid = false;
      }

      if(valid){
        fetch(localStorage.getItem('server') + 'renew/payment', {
          method: 'POST',
          body: JSON.stringify({
            Name: paymentData.name,
            Number: paymentData.noEncrypt,
            ExpiryMonth: paymentData.expiryMonth,
            ExpiryYear: paymentData.expiryYear,
            CVN: paymentData.cvcEncrypt,
            length: paymentData.length,
            memberNumber: sessionStorage.getItem('memberNumber')
          }),
          headers: {
            token: sessionStorage.getItem('token'),
            memberNumber: sessionStorage.getItem('memberNumber')
          }
        })
        .then(function(response){
          setProcessingPayment(false);
          return response.json();
        })
        .then(function(data){
          if(data.status === 401){
            // console.log("Invalid Token - Redirecting to login");
            // props.history.push("");
            alert.show(
              <span ref={sessionRef}>
                  Your session has expired. Please login to continue.
              </span>
              , {
                  title: "Session Expired"
          });
        } else {
          if(data.success){
            setExpiry(data.expiry);
            // console.log(data.expiry);
            // console.log(data.expiry.substr(0, data.expiry.indexOf(' ')).replaceAll('/', '-'));
            // console.log(data.expiry.replace(/\//g, '-'));
            var expiryString = new Date(data.expiry).toLocaleString('en-AU', {dateStyle: 'full'});
            setExpiry(expiryString);
            resolve({success: true});
          }
          else
            resolve({success: false, message: data.message});
        }
        });
      } else {
        resolve({success: false, message:'Please complete the entire form'});
      }
    });
  };

  const updateSubscriptions = () =>{
    return new Promise(function(resolve, reject){
      // console.log("UPDATING SUBSCRIPTIONS");
      var tempSubscriptionsData = subscriptionsData;
      tempSubscriptionsData.isRenew = true;
      // console.log(tempSubscriptionsData);
      fetch(localStorage.getItem('server') + 'subscription', {
        method: 'POST',
        headers: {
          token: sessionStorage.getItem('token'),
          memberNumber: sessionStorage.getItem('memberNumber')
        },
        body: JSON.stringify(tempSubscriptionsData)
      })
      .then(function(response){
        return response.json();
      })
      .then(function(data){
        if(data.status === 401){
          // console.log("Invalid Token - Redirecting to login");
          // props.history.push("");
          alert.show(
            <span ref={sessionRef}>
                Your session has expired. Please login to continue.
            </span>
            , {
                title: "Session Expired"
        });
        } else {
        if(data.status === 200){
          resolve({success: true});
        } else {
          resolve({success: false, message: data.message});
        }
      }
      });
    });
  }

  //After the user hits finish in the last step, this will grab all the users data, run validation, save it, then process the payment
  //Will proceed to the confirmation page if everything is all good and will return true. Else return false with the correct error message
  const saveRenew = ()=>{
    // if(!detailsData.email || !detailsData.mobilePhone || !detailsData.jobTitle){
    //   setActiveStep(0);
    //   setNotLoading(true);
    //   alert.show("Please complete all compulsory fields", {
    //     title: "Missing Fields"
    //   });
    //   return null;
    // }
    setProcessingPayment(true);
    setNotLoading(false);
    // console.log("Processing Renewal");
    
    //validate personal details and save it to database
    updatePersonalDetails()
    .then(function(outcome){
      if(outcome.success){
        // console.log("SUCCESSFULLY UPDATED PERSONAL DETAILS");
        //Update Subscriptions
        updateSubscriptions()
        .then(function(outcome){
          // setNotLoading(true);
          if(outcome.success){
            // console.log("SUCCESSFULLY UPDATED SUBSCRIPTIONS");
            //Handle payment
            handlePayment()
            .then(function(outcome){
              setProcessingPayment(false);
              // console.log(outcome);
              // setNotLoading(true);
              if(outcome.success){
                setNotLoading(true);
                setDisableNext(true);
                setActiveStep(activeStep + 1);
              } else {
                setNotLoading(true);
                alert.show(outcome.message, {
                  title: "Payment Failed"
                });
              }
            });
          } else {
            setNotLoading(true);
            setProcessingPayment(false);
            alert.show("An Unexpected error has occured. Please try again later.", {
              title: "Unable to Process"
            });
            // console.log("AN UNEXPECTED ERROR OCCURED");
          }
        });
      } else {
        setProcessingPayment(false);
        //Set up a popup here to display the error.
        // console.log(outcome.message);
        alert.show(outcome.message, {
          title: "Personal Details"
        });
        setActiveStep(0);
        setNotLoading(true);
      }
    });

    // setNotLoading(true);
    // return false;
  }

  const handleNext = () => {
    var success = true;

    //Run the function if the user clicks the next button and is in the appropriate page
    switch(activeStep){
      case 0:
        setEditedDetails(true);
        //Disables all the error icons while running test
        setInvalidHomePhone(true);

        //Run basic validation
        var homePhoneCheck = detailsData.homePhone.replaceAll(' ', '');
        if((!/^\d+$/.test(homePhoneCheck) || (homePhoneCheck.length !== 8 && homePhoneCheck.length !== 10)) && homePhoneCheck.length !== 0){
          console.log("Home phone validation failed");
          setInvalidHomePhone(false);
          success = false;
        }
        break;
      case 1:
        setEditedSubscriptions(true);
        if(paymentData.cvn && paymentData.expiryMonth && paymentData.expiryYear && paymentData.length && paymentData.name && paymentData.number){
          setDisableNext(false);
        } else {
          setDisableNext(true);
        }
        break;
      case 2:
        success = saveRenew();
        break;
      default:
        break;
    }
    if(success)
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    // if(activeStep === 2)
    //   setEditedPayment(true);

    switch(activeStep){
      case 0:
        redirectHome();
        break;
      case 1:
        setEditedSubscriptions(true);
        break;
      case 2:
        setEditedPayment(true);
        setDisableNext(false);
        break;
      default:
        break;
    }

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // const handleReset = () => {
  //   setActiveStep(0);
  // };

  const redirectHome = () =>{
    props.history.push('/home')
  }

  const sessionRef = (node)=>{
    if(node === null){
      window.location.replace(window.location.origin);
    }
  }

  //Returns the renew form if the member needs to renew, else return a no need to renew page
  if(renew){
    return (
      <div>
        {processingPayment === true &&       
          <Prompt message="Are you sure you wish to leave? The payment will still be processed and your membership will still be renewed." />
        }

      <div className="overlay" hidden={notLoading}>
        <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
      </div>
      <div className={classes.root}>
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              <Typography component={'span'} className={classes.instructions}>
                <h1 id="gtm-renew" className="text-center"><strong>Success</strong></h1>
                <p className="text-center">Your membership has been successfully renewed!</p>
                <p className="text-center">Your membership will expire on: <strong>{expiry}</strong></p>
              </Typography>
              <button onClick={redirectHome} className="form-btn renew-home-btn btn btn-primary">
                Home
              </button>
              {/* <Button onClick={handleReset} className={classes.button}>
                Reset
              </Button> */}
            </div>
          ) : (
            <div>
              <Typography component={'span'} className={classes.instructions}>{getStepContent(activeStep, editedDetails)}</Typography>
              <div className="step-btns">
                <Button onClick={handleBack} hidden={activeStep === 3} className={classes.button}>
                  {activeStep === 0 ? 'Home' : 'Back'}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                  disabled={disableNext}
                >
                  {/* {activeStep === steps.length - 1 ? 'Finish' : 'Next'} */}
                  {activeStep === 2 ? 'Finish' : 'Next'}

                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      </div>
    );
  } else {
    return(
      <div className="container">
        <h2 className="text-center"><strong>Renewal</strong></h2>
        {/* <p className="text-justify">Our records show your membership is still valid until <strong>{renewDate}</strong>. Please contact Bankstown Sports on 02 9722 9888 if you have any queries or visit this page closer to your expiry date.</p> */}
        <p className="text-justify">Your membership is valid until the <strong>{renewDate}</strong>. We will send you an email or SMS to let you know when it is time to renew. <span className="point-cursor" onClick={()=>{props.history.push("/details")}}><u>Click here</u></span> to check your details are up to date so you don’t miss out! </p>
        <button className="form-btn btn btn-primary " onClick={redirectHome}>Back</button>
      </div>
    )
  }
}
